var React = require('react');

function ContentClock (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n    .content-clock-svg{fill-rule:evenodd;clip-rule:evenodd;}\r\n  "),React.createElement("path",{"className":"content-clock-svg","d":"M21.5,39.3c-9.9,0-17.9-8-17.9-17.9s8-17.9,17.9-17.9s17.8,8,17.8,17.9S31.3,39.3,21.5,39.3 M21.5,0 C33.3,0,43,9.6,43,21.5S33.3,43,21.5,43S0,33.3,0,21.5S9.6,0,21.5,0L21.5,0z M21.5,7.3c-1,0-1.8,0.8-1.8,1.8v12.4v0 c0,0.5,0.2,0.9,0.5,1.3l8.8,8.8c0.3,0.4,0.8,0.5,1.3,0.5s0.9-0.2,1.3-0.5c0.7-0.7,0.7-1.9,0-2.6l-8.2-8.2V9.1 C23.3,8.1,22.5,7.3,21.5,7.3L21.5,7.3z","key":1})]);
}

ContentClock.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 43 43","style":{"enableBackground":"new 0 0 43 43"},"xmlSpace":"preserve"};

module.exports = ContentClock;

ContentClock.default = ContentClock;
